module.exports = __webpack_public_path__ + "img/vehicle-test-03.038d87f2.png";